var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-0.5 cursor-pointer self-start",on:{"click":function($event){return _vm.$emit('toggle')}}},[_c('font-awesome-icon',{staticClass:"text-blue-700 hover:text-blue-400 mr-2",attrs:{"icon":['fal', _vm.expanded ? 'chevron-down' : 'chevron-right']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }